import type { RouteObject } from "react-router";

import { Outlet } from "react-router";
import { lazy, Suspense } from "react";

import { CONFIG } from "src/global-config";
import { DashboardLayout } from "src/layouts/dashboard";

import { LoadingScreen } from "src/components/loading-screen";

import { AuthGuard } from "src/auth/guard";

import { usePathname } from "../hooks";

// ----------------------------------------------------------------------

const DashboardPage = lazy(() => import("src/pages/dashboard/dashboard"));
const UserPage = lazy(() => import("src/pages/dashboard/user"));
const Restaurants = lazy(() => import("src/pages/dashboard/restaurant"));
const ChangePasswordPage = lazy(
  () => import("src/pages/dashboard/change-password")
);
const BookingPage = lazy(() => import("src/pages/dashboard/booking"));
const RevenuePage = lazy(() => import("src/pages/dashboard/revenue"));
const SurveyPage = lazy(() => import("src/pages/dashboard/survey"));
const SubscriptionPage = lazy(() => import("src/pages/dashboard/subscription"));
const AppVersionPage = lazy(() => import("src/pages/dashboard/app-version"));

// ----------------------------------------------------------------------

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  );
}

const dashboardLayout = () => (
  <DashboardLayout>
    <SuspenseOutlet />
  </DashboardLayout>
);

export const dashboardRoutes: RouteObject[] = [
  {
    path: "/",
    element: CONFIG.auth.skip ? (
      dashboardLayout()
    ) : (
      <AuthGuard>{dashboardLayout()}</AuthGuard>
    ),
    children: [
      { path: "dashboard", element: <DashboardPage />, index: true },
      { path: "users", element: <UserPage /> },
      { path: "change-password", element: <ChangePasswordPage /> },
      { path: "restaurants", element: <Restaurants /> },
      { path: "bookings", element: <BookingPage /> },
      { path: "revenue", element: <RevenuePage /> },
      { path: "survey", element: <SurveyPage /> },
      { path: "subscriptions", element: <SubscriptionPage /> },
      { path: "app-versions", element: <AppVersionPage /> },


      // {
      //   path: "group",
      //   children: [
      //     { element: <PageFour />, index: true },
      //     { path: "five", element: <PageFive /> },
      //     { path: "six", element: <PageSix /> },
      //   ],
      // },
    ],
  },
];
